/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import React from 'react';
import { Skeleton } from '../console/ui';

const ProjectLoadingState: React.FC = () => {
    return (
        <div
            className="grid gap-4 [grid-template-columns:repeat(auto-fill,minmax(min(100%,320px),1fr))]"
            aria-busy="true"
            aria-label="Loading projects"
        >
            {[0, 1, 2].map((i) => (
                <Skeleton key={i} className="h-[196px] rounded-[14px]" />
            ))}
        </div>
    );
};

export default ProjectLoadingState;
